import { useQuery } from '@apollo/client/react';
import { Avatar, type AvatarProps } from 'antd';
import React from 'react';
import GET_PARTNER_LOGO from './queries/GetPartnerLogoUrl';

interface PartnerAvatarProps extends AvatarProps {
  id: string;
}

const PartnerAvatar = function ({ id, ...props }: PartnerAvatarProps) {
  const { data: { partner } = {}, loading } = useQuery(GET_PARTNER_LOGO, {
    variables: { id },
  });
  const chatWidgetPhotoUrl = partner?.settings?.appearance?.chatWidgetPhotoUrl;

  return loading ? (
    <Avatar style={{ backgroundColor: 'transparent' }} {...props} />
  ) : (
    <Avatar src={chatWidgetPhotoUrl} {...props} />
  );
};

export default PartnerAvatar;
